import { tryLoadLightDOMStyles } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader-Level1.styles'

const t = document.createElement('template')
t.innerHTML = `
  <!-- TODO: class needed for "menu-open" -->
  <header class="ascend-header ascend-header-level1 header-inner" role="banner">
    <!-- Top Header: -->
    <nav class="main-nav" role="navigation" aria-label="Main Navigation">
      <!-- logo -->
      <slot name="logo"></slot>
      <!-- Site action & profile menu -->
      <slot name="utilityNavigation"></slot>
    </nav>

    <slot name="primaryNavigationMobile"></slot>
    <div class="tab-header">
      <slot name="primarySearchContainer"></slot>
      <slot name="primaryNavigation"></slot>
    </div>
    
  </header>
`
const TemplateNavHeader = t

class NavHeader extends HTMLElement {
  private isOpen = false

  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavHeader.content.cloneNode(true))

    tryLoadLightDOMStyles('NavHeader-Level1.css')
  }

  connectedCallback() {
    console.log('NavigationHeaderLevel1 connectedCallback')

    this.addEventListener('toggle-hamburger', () => {
      this.isOpen = !this.isOpen
      this.classList.toggle('mobile-nav-open', this.isOpen)
    })

    this.addEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.addEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }
  disconnectedCallback() {
    this.removeEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.removeEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }

  private handleSearchStateChange = (event: CustomEvent) => {
    const { visible } = event.detail
    const value = visible.toString()

    // Desktop / mobile search containers
    this.querySelectorAll('ts-navheader-search-container').forEach((el) =>
      el.setAttribute('search-visible', value),
    )

    // Utility button for search 
    this.querySelectorAll('ts-navheader-utility-search-button').forEach((el) =>
      el.setAttribute('search-visible', value),
    )
    // Utility search icon
    this.querySelectorAll('ts-navheader-utility-search').forEach((el) =>
      el.setAttribute('search-visible', value),
    )
  }

  private handleSearchIconClick = (event: CustomEvent) => {
    console.log('Search icon clicked:', event.detail)
  }
}
if (!customElements.get('ts-navheader-level1')) {
  customElements.define('ts-navheader-level1', NavHeader)
}
export { NavHeader }
